<template>
    <div class="row m-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p>Saya yang bertanda tangan di bawah ini:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianName }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <input v-model="GuardianName" type="text" class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">tanggal lahir</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianDateBirth }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <date-picker :value-type="SuratPersetujuanDateFormat()"
                                                v-model="GuardianDateBirth" :format="SuratPersetujuanDateFormat()"
                                                :clearable="false" class="col-4" input-class="form-control"></date-picker>
                                        </div>
                                        <div class="row">
                                            <span class="col-4 text-danger">{{ errors[0] }}</span>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianSex }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <input v-model="GuardianSex" type="text" class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianAddress }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <textarea v-model="GuardianAddress" type="text"
                                                    class="w-100 form-control"></textarea>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="pl-0">
                                <div class="d-flex align-items-center">
                                    <p class="mb-0">
                                        Hubungan dengan pasien: Saya Sendiri / Anak / Istri / Suami / Ayah / Ibu / Wali
                                    </p>
                                    <div class="d-flex align-items-center">
                                        <p class="mb-0 mr-2">/</p>
                                        <template v-if="CurrentlyPrintingLetter">
                                            <span>{{ GuardianRelationship }}</span>
                                        </template>
                                        <template v-else>
                                            <validation-provider rules="required" v-slot="{ errors }" tag="span">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <input v-model="GuardianRelationship" type="text"
                                                            class=" form-control" />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div>
                                                </div>
                                            </validation-provider>
                                        </template>
                                    </div>
                                </div>
                                <p class="mb-0">Menyatakan dengan sesungguhnya telah memberikan</p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="pl-0">
                                <h6 class="my-3 text-uppercase font-weight-bold">
                                    persetujuan/penolakan
                                </h6>

                                <p class="mt-3">Terhadap pelepasan informasi isi rekam medis atas nama:</p>

                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">no. rekam medis</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienMRN }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">tanggal lahir</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ SuratPersetujuanDate(PasienDateBirth) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                    </table>

                    <p>
                        kepada pihak-pihak antara lain:
                    </p>

                    <ol>
                        <li>
                            Pihak penjamin berupa hasil pembacaan dari hasil pemeriksaan penunjang
                        </li>
                        <li>
                            Pihak peserta didik berupa hasil pemeriksaan penunjang yang dapat diinformasikan/diakses
                        </li>
                        <li>
                            Pihak anggota keluarga lain yang dapat diberikan informasi data-data pasien:

                            <div class="row">
                                <div class="col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <font-awesome-icon class="mr-1" icon="circle" style="font-size: 5px" />
                                        <span>Nama
                                            keluarga Ke-1 :
                                        </span>
                                        <template v-if="CurrentlyPrintingLetter">
                                            <span class="ml-2">{{ FamilyRelation1 }}</span>
                                        </template>
                                        <template v-else>
                                            <validation-provider v-slot="{ errors }" tag="div"
                                                style="margin-left: 0.8rem !important">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-auto">
                                                        <input v-model="FamilyRelation1" type="text"
                                                            class=" form-control" />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div>
                                                </div>
                                            </validation-provider>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <font-awesome-icon class="mr-1" icon="circle" style="font-size: 5px" />
                                        <span>Nama
                                            keluarga Ke-2 :
                                        </span>
                                        <template v-if="CurrentlyPrintingLetter">
                                            <span class="ml-2">{{ FamilyRelation2 }}</span>
                                        </template>
                                        <template v-else>
                                            <validation-provider v-slot="{ errors }" tag="div" class="ml-2">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-auto">
                                                        <input v-model="FamilyRelation2" type="text"
                                                            class=" form-control" />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div>
                                                </div>
                                            </validation-provider>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <font-awesome-icon class="mr-1" icon="circle" style="font-size: 5px" />
                                        <span>Nama
                                            keluarga Ke-3 :
                                        </span>
                                        <template v-if="CurrentlyPrintingLetter">
                                            <span class="ml-2">{{ FamilyRelation3 }}</span>
                                        </template>
                                        <template v-else>
                                            <validation-provider v-slot="{ errors }" tag="div" class="ml-2">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-auto">
                                                        <input v-model="FamilyRelation3" type="text"
                                                            class=" form-control" />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div>
                                                </div>
                                            </validation-provider>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>Pihak fasilitas kesehatan rujukan</li>
                    </ol>

                    <p style="margin-left: calc(40px - 22.8px)">dan memberikan akses informasi isi rekam medis kepada pihak
                        lainnya yang berhak berdasarkan <br />
                        kebijakan fasilitas kesehatan dan peraturan yang berlaku.
                    </p>

                </div>
            </div>
        </div>


        <div class="col-12 mt-4">
            <div class="row">
                <div class="col-12">
                    <p style="margin-bottom: 3px">{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12 time-section">
                    <p class="text-capitalize mb-4">jam: {{ SuratDateTimeRecorded }}</p>
                </div>

                <div class="col-12">
                    <div class="row mt-4">
                        <div class="col-6">
                            <p class="text-capitalize mb-4">pemberi pernyataan</p>

                            <template v-if="CurrentlyPrintingLetter">
                                <span class="d-block float-left" style="margin-top: 5em">
                                    {{ GuardianName }}
                                    <hr />
                                </span>
                            </template>
                            <template v-else>
                                <validation-provider style="margin-top: 5em" rules="required" v-slot="{ errors }" tag="div">
                                    <div class="mt-4 d-flex align-items-center">
                                        <div class="w-50">
                                            <input disabled v-model="GuardianName" type="text" class=" form-control" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                            <hr />
                                        </div>
                                    </div>
                                </validation-provider>
                            </template>
                        </div>
                        <div class="col-6">
                            <p class="text-capitalize ml-4 pl-4 mb-4">petugas</p>

                            <template v-if="CurrentlyPrintingLetter">
                                <span class="d-block float-left ml-4 pl-4" style="margin-top: 5em">
                                    {{ PetugasPemberiPernyataan }}
                                    <hr />
                                </span>
                            </template>
                            <template v-else>
                                <validation-provider style="margin-top: 5em" rules="required" v-slot="{ errors }" tag="div">
                                    <div class="ml-4 pl-4 mt-4 d-flex align-items-center">
                                        <div class="w-100">
                                            <div class="w-50">
                                                <input v-model="PetugasPemberiPernyataan" type="text"
                                                    class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </validation-provider>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign :increaseFont="false" />
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCircle);

import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDateTime, SuratDatePickerFormat, SuratPersetujuanDateFormat, SuratPersetujuanDate } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'

export default {
    name: 'SuratPersetujuanPelepasanInformasiBody',
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        DatePicker: () => import('vue2-datepicker'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            GuardianName: null,
            GuardianDateBirth: null,
            GuardianSex: null,
            GuardianAddress: null,
            GuardianRelationship: null,
            PasienName: null,
            PasienAge: null,
            PasienMRN: null,
            PasienDateBirth: null,
            PasienSex: null,
            FamilyRelation1: null,
            FamilyRelation2: null,
            FamilyRelation3: null,
            PetugasPemberiPernyataan: null,
            SuratDateTimeRecorded: null,
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('ComponentMounted')
            this.SuratDateTimeRecorded = this.SuratDateTime()
        })
    },
    computed: {
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'LetterID', 'TransKlinikIDFromPembayaran', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'TransKlinikID']),
        SuratPersetujuanPelepasanInformasiEndpoint() {
            return `${this.API_URL}/surat-persetujuan-pelepasan-informasi`
        },
        PayloadBackend() {
            return {
                nama: this.GuardianName,
                tanggalLahir: this.GuardianDateBirth,
                jenisKelamin: this.GuardianSex,
                alamat: this.GuardianAddress,
                hubunganDenganPasien: this.GuardianRelationship,
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                nomorRekamMedisPasien: this.PasienMRN,
                tglLahirPasien: this.PasienDateBirth,
                jenisKelaminPasien: this.PasienSex,
                namaKeluarga1Pasien: this.FamilyRelation1,
                namaKeluarga2Pasien: this.FamilyRelation2,
                namaKeluarga3Pasien: this.FamilyRelation3,
                petugasPemberiPernyataan: this.PetugasPemberiPernyataan,
                jamSurat: this.SuratDateTimeRecorded,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage ? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber
            }
        },
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        SuratDateTime,
        SuratPersetujuanDateFormat,
        SuratPersetujuanDate,
        async GetData() {
            this.SET_LOADING(true)

            this.$nextTick(async () => {
                const { data } = await this.$axios.get(`${this.SuratPersetujuanPelepasanInformasiEndpoint}/${this.LetterID}`);

                this.GuardianName = data.nama
                this.GuardianDateBirth = data.tanggal_lahir
                this.GuardianSex = data.jenis_kelamin
                this.GuardianAddress = data.alamat
                this.GuardianRelationship = data.hubungan_dengan_pasien
                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienMRN = data.nomor_rekam_medis_pasien
                this.PasienDateBirth = data.tgl_lahir_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.FamilyRelation1 = data.nama_keluarga_1_pasien
                this.FamilyRelation2 = data.nama_keluarga_2_pasien
                this.FamilyRelation3 = data.nama_keluarga_3_pasien
                this.PetugasPemberiPernyataan = data.petugas_pemberi_pernyataan
                this.SuratDateTimeRecorded = data.jam_surat

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })
        },
        async UpdateData() {
            const { data } = await this.$axios.put(`${this.SuratPersetujuanPelepasanInformasiEndpoint}/${this.LetterID}`, this.PayloadBackend);
            return data;
        },
        async SaveData() {
            const { data } = await this.$axios.post(`${this.SuratPersetujuanPelepasanInformasiEndpoint}/create`, this.PayloadBackend);
            return data;
        },
    }
}
</script>

<style scoped lang="scss">
table {
    tr {
        td {
            padding-bottom: 10px;
            // font-size: 16pt;
        }
    }
}

ol {
    li {

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
            padding-bottom: 9px;
        }

        &:nth-child(3) {
            &>.row {
                margin-top: 10px;
            }
        }
    }
}

.time-section {
    margin-top: 9px;
}

// .fs-12 {
//     font-size: 16pt !important;
// }
</style>